import { render, staticRenderFns } from "./ItemsSelector.vue?vue&type=template&id=36a93096&scoped=true&"
import script from "./ItemsSelector.vue?vue&type=script&lang=js&"
export * from "./ItemsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a93096",
  null
  
)

export default component.exports